/**
 * Pre-order block visibility - shows/hides based on variant custom.pre_order metafield.
 * Listens to theme:variant:change for AJAX-style refresh on variant selection.
 */
(function() {
  'use strict';

  const PREORDER_BLOCK_SELECTOR = '[data-preorder-block]';
  const VARIANT_METAFIELDS_SELECTOR = '[data-variant-metafields]';
  const HIDDEN_CLASS = 'hidden';

  function isVariantPreorder(variant, metafieldsData) {
    if (!variant || !metafieldsData) return false;

    try {
      const variantsMetafields = JSON.parse(metafieldsData);
      const match = variantsMetafields.find(function(m) {
        return Number(m.variant_id) === variant.id;
      });
      return match && match.preorder === 'true';
    } catch (e) {
      return false;
    }
  }

  function updatePreorderBlockVisibility(container, variant, metafieldsEl) {
    const block = container.querySelector(PREORDER_BLOCK_SELECTOR);
    if (!block) return;

    const metafieldsData = metafieldsEl ? metafieldsEl.textContent : null;
    const show = isVariantPreorder(variant, metafieldsData);
    block.classList.toggle(HIDDEN_CLASS, !show);
  }

  function init() {
    const productSections = document.querySelectorAll('[data-section-type="product"]');

    productSections.forEach(function(section) {
      const preorderBlock = section.querySelector(PREORDER_BLOCK_SELECTOR);
      if (!preorderBlock) return;

      const container = section.closest('product-component') || section;
      const metafieldsEl = container.querySelector(VARIANT_METAFIELDS_SELECTOR);

      section.addEventListener('theme:variant:change', function(evt) {
        updatePreorderBlockVisibility(container, evt.detail && evt.detail.variant, metafieldsEl);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
